<style scoped lang="stylus" rel="stylesheet/stylus">
.content
  height 100%
  font-size 13px
  color #323233
  .area
    font-size 28px
    font-weight bold
    text-align left
    line-height 44px
    padding 16px 0 0 16px
  .options
    padding 0 7px 0 20px
    .icon
      font-size 8px
      margin 0 0 2px 6px
  .timeRang
    color #266BFF
    border-top 1px solid #DCDDE0
    padding-top 12px
    margin 20px 16px 12px
    .icon
      font-size 6px
      margin-left 10px
      transform rotate(90deg)

  .loadingTop
    position absolute
    top 10px
    left 0
    right 0
    width max-content
    margin auto
    z-index 100

  .container
    .tip
      color #C8C9CC
      font-size 10px
      text-align center
    .img-box
      padding-top 30px
      .rose-img
        width 100%
        height auto
      .source
        font-size 12px
        color #969799
        text-align center
        padding 30px 0
    .no-data
      display block
      margin 100px auto 0
      width 30%
</style>

<template>
	<div class="content">
		<div class="area">甘肃</div>
		<div class="flex-row-bet-cen options">
			<div v-if="cityPickerData.columns.length > 0" class="flex-row-sta-cen" @click="showCityPicker">
				<div>{{ checkedCity.areaName }}</div>
				<div class="jx-mb-arrow-right icon"></div>
			</div>
			<div v-else></div>
			<div class="flex-row-sta-cen" @click="showFacotrPicker">
				<div>{{ checkedFactor.text }}</div>
				<div class="jx-mb-arrow-right icon"></div>
			</div>
		</div>
		<div class="flex-row-cen-cen timeRang" @click="showTimePicker">
			<div>{{ startTime }} ~ {{ endTime }}</div>
			<div class="jx-mb-arrow-right icon"></div>
		</div>

		<van-loading v-if="showLoading" class="loadingTop" :size="15" :text-size="12" color="rgb(1,140,255)"
			>数据加载中</van-loading
		>
		<div class="container">
			<div class="tip">建议选择5天以上</div>
			<div v-if="imgSrc" class="img-box">
				<img class="rose-img" :src="imgSrc" alt="污染玫瑰图" />
				<div class="source">数据来源：中央环境监测总站</div>
			</div>
			<img class="no-data" v-else-if="!showLoading" src="../../assets/images/nodata.png" />
		</div>

		<picker v-model="isShowCityPicker" :pickdata="cityPickerData" @confirm="cityPicked"></picker>
		<picker v-model="isShowFactorPicker" :pickdata="factorPickerData" @confirm="factorPicked"></picker>
		<picker-time-range
			type="day"
			tip="建议五天以上"
			v-model="isShowTimePicker"
			:init-start-time="startTime"
			:init-end-time="endTime"
			@confirm="timePicked"
		></picker-time-range>
		<home-btn />
	</div>
</template>

<script>
import picker from '../../components/form/picker'
import pickerTimeRange from '../../components/form/picker-time-range'
import homeBtn from '../../components/navigation/home-btn'

export default {
	name: 'pollutionRose',
	components: {
		picker,
		pickerTimeRange,
		homeBtn
	},
	data() {
		let creatDate = new Date()
		let preDate = new Date(creatDate.getTime() - 3600 * 1000 * 24 * 7)
		return {
			showLoading: true, // 控制加载提示

			isShowCityPicker: false, // 控制城市弹窗
			cityPickerData: {
				// 城市弹窗选项数据
				title: '城市选择',
				columns: [],
				valueKey: 'areaName'
			},
			checkedCity: {}, // 被选中城市

			isShowFactorPicker: false, // 控制因子弹窗
			factorPickerData: {
				// 因子弹窗选项数据
				title: '因子选择',
				columns: [
					{ text: 'AQI', code: 'aqi' },
					{ text: 'PM₂.₅', code: 'pm25' },
					{ text: 'PM₁₀', code: 'pm10' },
					{ text: 'O₃', code: 'o3' },
					{ text: 'SO₂', code: 'so2' },
					{ text: 'NO₂', code: 'no2' },
					{ text: 'CO', code: 'co' }
				],
				valueKey: 'text'
			},
			checkedFactor: {}, // 被选中因子

			currChannel: 0, // 当前通道
			checkedSiteCodes: '', // 当前通道下被选中站点

			isShowTimePicker: false, // 控制时间段选择弹窗
			startTime: preDate.format('YYYY-MM-dd') + ' 00:00:00', // 开始时间
			endTime: creatDate.format('YYYY-MM-dd') + ' 00:00:00', // 结束时间

			imgSrc: ''
		}
	},
	created() {
		this.initPage()
	},
	mounted() {},
	methods: {
		// 初始化页面数据
		async initPage() {
			this.checkedFactor = this.factorPickerData.columns[0]
			this.cityPickerData.columns = await this.getCityPickerData()
			this.checkedCity = this.cityPickerData.columns[0] || {}
			this.imgSrc = await this.getImgSrc()
		},
		// 获取所有城市
		async getCityPickerData() {
			//            let params = {
			//                siteTypeCodes: 'transPathOne,transPathTwo',
			//            };
			//            let res = await this.$http.getSitesByGroup(params);
			let res = {
				status: 0,
				message: null,
				errorCode: 0,
				type: null,
				data: [
					{
						errcode: 0,
						errmsg: null,
						retstatus: null,
						rettype: null,
						siteCode: '620000000004',
						siteName: '嘉峪关环保局',
						areaName: '嘉峪关'
					},
					{
						errcode: 0,
						errmsg: null,
						retstatus: null,
						rettype: null,
						siteCode: '620000000010',
						siteName: '金昌气象局',
						areaName: '金昌'
					},
					{
						errcode: 0,
						errmsg: null,
						retstatus: null,
						rettype: null,
						siteCode: '620000000002',
						siteName: '武威理工中专站',
						areaName: '武威'
					},
					{
						errcode: 0,
						errmsg: null,
						retstatus: null,
						rettype: null,
						siteCode: '620000000021',
						siteName: '阿克塞司法局站',
						areaName: '阿克塞哈萨克族自治县'
					},
					{
						errcode: 0,
						errmsg: null,
						retstatus: null,
						rettype: null,
						siteCode: '620000000005',
						siteName: '玉门市新市区统办楼站',
						areaName: '玉门市'
					},
					{
						errcode: 0,
						errmsg: null,
						retstatus: null,
						rettype: null,
						siteCode: '620000000006',
						siteName: '金塔中学',
						areaName: '金塔县'
					},
					{
						errcode: 0,
						errmsg: null,
						retstatus: null,
						rettype: null,
						siteCode: '620000000001',
						siteName: '白银市实验中学',
						areaName: '白银'
					},
					{
						errcode: 0,
						errmsg: null,
						retstatus: null,
						rettype: null,
						siteCode: '620000000013',
						siteName: '现代职业学院',
						areaName: '临夏回族自治州'
					},
					{
						errcode: 0,
						errmsg: null,
						retstatus: null,
						rettype: null,
						siteCode: '620000000014',
						siteName: '碌曲县藏族中学',
						areaName: '碌曲县'
					},
					{
						errcode: 0,
						errmsg: null,
						retstatus: null,
						rettype: null,
						siteCode: '620000000003',
						siteName: '定西市环保局',
						areaName: '定西'
					},
					{
						errcode: 0,
						errmsg: null,
						retstatus: null,
						rettype: null,
						siteCode: '620000000018',
						siteName: '陇南环保局',
						areaName: '陇南'
					},
					{
						errcode: 0,
						errmsg: null,
						retstatus: null,
						rettype: null,
						siteCode: '620000000016',
						siteName: '广成大酒店',
						areaName: '平凉'
					},
					{
						errcode: 0,
						errmsg: null,
						retstatus: null,
						rettype: null,
						siteCode: '620000000012',
						siteName: '兰州',
						areaName: '兰州'
					}
				]
			}
			if (res.status === 0 && res.data && res.data.length > 0) {
				return res.data
			} else {
				this.$notify({ type: 'warning', message: '获取城市列表失败' })
				return []
			}
		},
		// 获取污染玫瑰数据
		async getImgSrc() {
			this.showLoading = true
			//            let params = {
			//                dataSource: 'reality',
			//                dataStatus: 'raw',
			//                startTime: this.startTime,
			//                endTime: this.endTime,
			//                factorCode: this.checkedFactor.code,
			//                siteCode: this.checkedCity.siteCode,
			//                timeType: 'hh',
			//            };
			//            let res = await this.$http.getPollutionRose(params);
			let res = []
			if (res.status === 0 && res.data) {
				this.showLoading = false
				return res.data
			}
			this.showLoading = false
			return ''
		},
		// 显示城市选项弹窗
		showCityPicker() {
			this.isShowCityPicker = true
		},
		// 城市选项被选择
		async cityPicked(data) {
			this.checkedCity = data
			this.imgSrc = await this.getImgSrc()
		},
		// 显示因子选项弹窗
		showFacotrPicker() {
			this.isShowFactorPicker = true
		},
		// 因子选项被选择
		async factorPicked(data) {
			this.checkedFactor = data
			this.imgSrc = await this.getImgSrc()
		},
		// 显示时间段选项弹窗
		showTimePicker() {
			this.isShowTimePicker = true
		},
		// 时间段选项选择
		async timePicked(data) {
			this.startTime = data.startTime
			this.endTime = data.endTime
			this.imgSrc = await this.getImgSrc()
		},
		// 跳至首页
		gotoHome() {
			this.$router.push('newHome')
		}
	}
}
</script>
